var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "canvas_boxs" }, [
    _c(
      "div",
      {
        ref: "mycanvas",
        staticClass: "canvas_box",
        style: _vm.getBgBox(),
        attrs: { id: _vm.model.pageId + "mycanvas" },
      },
      [
        _c("div", { staticStyle: { height: "1px" } }, [_vm._v(" ")]),
        _vm._v(" "),
        _vm.imgUrl
          ? _c("div", { staticClass: "buildingBox", style: _vm.getBg() }, [
              _c("img", {
                attrs: { src: "data:image/png;base64," + _vm.baseUrl },
              }),
              _vm._v(" "),
              _vm.isChange
                ? _c(
                    "div",
                    _vm._l(_vm.totalPage, function (item, num) {
                      return _c(
                        "div",
                        { key: num },
                        _vm._l(item, function (i, n) {
                          return _c(
                            "div",
                            {
                              key: n,
                              staticClass: "buildingBox-item",
                              style: _vm.getStyle(i, num, n),
                              on: {
                                mousedown: function ($event) {
                                  return _vm.move($event, num, n)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n               " +
                                  _vm._s(i.name) +
                                  " \n             "
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              this.currentPage > 0
                ? _c(
                    "div",
                    {
                      staticClass: "buildingBox-subNext",
                      on: { click: _vm.prePage },
                    },
                    [_vm._v("上一页")]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.currentPage < this.pageNum - 1
                ? _c(
                    "div",
                    {
                      staticClass: "buildingBox-next",
                      on: { click: _vm.nextPage },
                    },
                    [_vm._v("下一页")]
                  )
                : _vm._e(),
            ])
          : _c(
              "div",
              {
                staticClass: "buildingBoxelse",
                on: {
                  click: function ($event) {
                    return _vm.uploadInitImg()
                  },
                },
              },
              [
                _c("div", { staticClass: "buildingBoxelse-col" }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "buildingBoxelse-col buildingBoxelse-rol",
                }),
                _vm._v(" "),
                _c("div"),
                _vm._v("\n              请上传照片\n       "),
              ]
            ),
        _vm._v(" "),
        _vm.imgUrl
          ? _c(
              "div",
              { staticClass: "buildingNav" },
              _vm._l(_vm.buildingObj.saleStatusBeanList, function (i, n) {
                return _c(
                  "div",
                  {
                    key: n,
                    staticClass: "buildingNav-item",
                    style: _vm.getColorStyle(i, n),
                  },
                  [
                    _vm._v(
                      "\n             " + _vm._s(i.name) + " \n           "
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticStyle: { height: "1px" } }, [_vm._v(" ")]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }